module.exports = __webpack_public_path__ + "static/media/G1246957_Japan-17.43f35bd7.png";